import type { PurchaseResult } from "@/platform/types";

/**
 * 앱 수명 동안 제출 중이거나 지급이 끝난 증빙. 구매 흐름(usePurchase)과 복구(usePurchaseRecovery)가 같은 증빙을 겹쳐 내지 않게 한다
 * (결제창이 닫히며 포그라운드 복구가 방금 산 미소비 구매를 다시 집는 경우). 실패하면 release 로 풀어 다음 복구가 다시 시도한다.
 */
const claimed = new Set<string>();
const keyOf = (p: PurchaseResult) => (p.store === "apple" ? `apple:${p.transactionId}` : `google:${p.purchaseToken}`);

export function claimPurchase(p: PurchaseResult): boolean {
  const key = keyOf(p);
  if (claimed.has(key)) return false;
  claimed.add(key);
  return true;
}

export function releasePurchase(p: PurchaseResult): void {
  claimed.delete(keyOf(p));
}

/** 결제창이 떠 있는 동안(usePurchase) 복구 스캔을 쉰다 — 결제창이 닫히며 오는 포그라운드 복귀가 방금 산 구매를 먼저 집지 않게 */
let purchasing = 0;
export const beginPurchase = () => void purchasing++;
export const endPurchase = () => void (purchasing = Math.max(0, purchasing - 1));
export const isPurchasing = () => purchasing > 0;

/** 테스트 전용 */
export function resetClaimedPurchases(): void {
  claimed.clear();
  purchasing = 0;
}
